import axios from '../axios'

export const selectAdminUser = params => {
    return axios({
        url: '/v1/adminUser',
        method: 'get',
        params
    })
};

export const insertAdminUser = data => {
    return axios({
        url: '/v1/adminUser',
        method: 'post',
        data
    })
};

export const deleteAdminUser = userId => {
    return axios({
        url: '/v1/adminUser/' + userId,
        method: 'delete'
    })
};

export const updateAdminUser = (data, userId) => {
    return axios({
        url: '/v1/adminUser/' + userId,
        method: 'put',
        data
    })
};

export const updateAdminUserPassword = (data, userId) => {
    return axios({
        url: '/v1/adminUser/' + userId + '/password',
        method: 'put',
        data
    })
};